import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

export abstract class IIntegrationTriggerApi {
  abstract getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>>;
}

